import React, { useState } from "react";
import { Alert, Button, Col, Form, Modal, Spinner } from "react-bootstrap";



const DeleteCard = ({ show, customer, card, handleClose, handleSuccess}) => {
    const [submitting, setSubmitting] = useState(false);
    const [apiError, setApiError] = useState(undefined);
    const onSubmit = async (event) => {
        setSubmitting(true);
        setApiError(undefined);
        event.preventDefault();
        const sanitizedData = {
            userId: customer.profile.id,
            cardId : card.id
        };

        try {
            //console.log(sanitizedData);
            await handleSuccess(sanitizedData);
            setSubmitting(false);
        } catch (e) {
            setApiError(e?.message || "System error");
            setSubmitting(false);
            console.log(e)
        }
    }
    return (
        <Modal show={show} onHide={handleClose} size="lg">
              <Form onSubmit={onSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Credit Card</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Col>
                        Are you sure you want to delete this card ?
                    </Col>
                    {apiError && (
                        <Alert variant="danger">{apiError}</Alert>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" type="submit" disabled={submitting}>
                        {submitting && <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />}
                        Delete
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

export default DeleteCard;